import * as styles from "./ClientEditor.css";

import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";
import { Trans } from "@lingui/react/macro";

import { ClientEditorBody } from "./components/ClientEditorBody";
import { ClientEditorHeader } from "./components/ClientEditorHeader";
import {
  type UseClientEditorOptions,
  useClientEditor,
} from "./hooks/useClientEditor";

export type ClientEditorProps = UseClientEditorOptions;

export function ClientEditor({
  clientId = null,
  onSaved,
  onCancel,
}: ClientEditorProps): JSX.Element {
  const { loading, saving, error, conflict, save, cancel } = useClientEditor({
    clientId,
    onSaved,
    onCancel,
  });

  return (
    <div className={styles.editor}>
      <ClientEditorHeader />

      <ClientEditorBody loading={loading} error={error} conflict={conflict} />

      <footer className={styles.footer}>
        <Button variant="ghost" onClick={cancel}>
          <Trans>Cancel</Trans>
        </Button>

        <Button
          variant="primary"
          loading={saving}
          disabled={loading || saving}
          shortcut="mod+s"
          onClick={() => void save()}
        >
          <Trans>Save</Trans>
        </Button>
      </footer>
    </div>
  );
}
